// @ts-nocheck
/**
 * handle click on csv download invoice
 *
 * @param {string} csvString - The CSV data as a string.
 * @param {string} filename - The desired name for the downloaded file.
 */
export const downloadCSV = ({ csvString, filename }) => {
  // 1. Check for data
  if (!csvString) {
    console.error("No CSV data provided to download.");
    return;
  }

  // 2. Create a Blob from the CSV string
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });

  // 3. Create a URL for the Blob
  const url = URL.createObjectURL(blob);

  // 4. Create a temporary anchor element
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden"; // Make it invisible

  // 5. Append to the DOM, click it, and then remove it
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // 6. Optional: Revoke the object URL to free up memory
  URL.revokeObjectURL(url);
};

/**
 * handle click on csv download for deposit invoice
 *
 * @param {string} csvString - The CSV data as a string.
 * @param {string} filename - The desired name for the downloaded file.
 */
export const downloadDepositInvoiceCSV = ({ csvString, filename }) => {
  // 1. Check for data
  if (!csvString) {
    console.error("No CSV data provided to download.");
    return;
  }

  // 2. Create a Blob from the CSV string
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });

  // 3. Create a URL for the Blob
  const url = URL.createObjectURL(blob);

  // 4. Create a temporary anchor element
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden"; // Make it invisible

  // 5. Append to the DOM, click it, and then remove it
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // 6. Optional: Revoke the object URL to free up memory
  URL.revokeObjectURL(url);
};

/**
 * Export errors to CSV file
 * @param {Array} errors - Array of error objects
 * @param {string} filename - Optional filename (defaults to 'bulk-update-errors.csv')
 */
export const exportErrorsToCSV = (
  errors,
  filename = "bulk-update-errors.csv",
) => {
  if (!errors || errors.length === 0) {
    console.warn("No errors to export");
    return;
  }

  // CSV Header
  let csv = "Profile ID,Name,Email,Errors\n";

  // CSV Rows
  errors.forEach((error) => {
    const profileId = error.profileId || "";
    const name = error.name || "";
    const email = error.email || "";

    // Handle both array of errors and single error string
    const errorList = Array.isArray(error.errors)
      ? error.errors
      : error.error
        ? [error.error]
        : [];

    // Join multiple errors with semicolon and escape quotes
    const errorText = errorList.join("\n").replace(/"/g, '""');

    csv += `"${profileId}","${name}","${email}","${errorText}"\n`;
  });

  // Create and download file
  downloadCSV({ csvString: csv, filename });
};

/**
 * Export successes to CSV file
 * @param {Array} successes - Array of success objects
 * @param {string} filename - Optional filename (defaults to 'bulk-update-successes.csv')
 */
export const exportSuccessesToCSV = (
  successes,
  filename = "bulk-update-successes.csv",
) => {
  if (!successes || successes.length === 0) {
    console.warn("No successes to export");
    return;
  }

  // CSV Header
  let csv = "Profile ID,Name,Email,Updates\n";

  // CSV Rows
  successes.forEach((success) => {
    const profileId = success.profileId || "";
    const name = success.name || "";
    const email = success.email || "";

    // Handle both array of successes and single success string
    const successList = Array.isArray(success.successes)
      ? success.successes
      : success.success
        ? [success.success]
        : [];

    // Join multiple successes with semicolon and escape quotes
    const successText = successList.join("\n").replace(/"/g, '""');

    csv += `"${profileId}","${name}","${email}","${successText}"\n`;
  });

  // Create and download file
  downloadCSV(csv, filename);
};